import React from "react";
import { Plus, X } from "lucide-react";
import { Section } from "./ReviewFields";

const fmt = (n) =>
  `${(parseFloat(n) || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function LineItemsSection({ extracted, updateLine, addLine, removeLine, sommaRighe }) {
  return (
    <Section
      title="RIGHE FATTURA"
      testid="section-righe"
      action={
        <button
          onClick={addLine}
          data-testid="add-line-btn"
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md text-xs font-medium border border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100 transition-colors"
        >
          <Plus className="w-3 h-3" /> Aggiungi riga
        </button>
      }
    >
      <p className="text-xs text-zinc-600 mb-4 leading-relaxed">
        <span className="font-semibold">L&apos;imponibile</span> (totale della fattura originale del fornitore estero) è la fonte di verità.
        {" "}L&apos;IVA al {extracted.aliquota_iva}% viene aggiunta in reverse charge. Se la somma delle righe non quadra con l&apos;imponibile,
        la differenza (max qualche centesimo) viene assorbita nell&apos;ultima riga al salvataggio.
      </p>

      <div className="space-y-3">
        {(extracted.line_items || []).map((li, idx) => (
          <div key={li.id ?? `line-${idx}`} className="grid grid-cols-1 md:grid-cols-12 gap-3 items-end rounded-lg border border-[#E8E4D9] bg-white p-3" data-testid={`line-row-${idx}`}>
            <div className="md:col-span-7">
              <label className="block text-[10px] font-medium text-zinc-500 uppercase tracking-wider mb-1">Descrizione</label>
              <input
                value={li.descrizione}
                onChange={(e) => updateLine(idx, "descrizione", e.target.value)}
                data-testid={`line-desc-${idx}`}
                className="w-full h-9 px-2 rounded-md border border-[#E8E4D9] bg-white text-sm focus:border-zinc-900 outline-none"
              />
            </div>
            <div className="md:col-span-4">
              <label className="block text-[10px] font-medium text-zinc-500 uppercase tracking-wider mb-1">Importo (EUR)</label>
              <input
                type="number"
                step="0.01"
                value={li.prezzo_totale}
                onChange={(e) => updateLine(idx, "prezzo_totale", parseFloat(e.target.value) || 0)}
                data-testid={`line-total-${idx}`}
                className="w-full h-9 px-2 rounded-md border border-[#E8E4D9] bg-white text-sm font-mono tabular-nums text-right focus:border-zinc-900 outline-none"
              />
            </div>
            <div className="md:col-span-1 flex md:justify-center">
              <button onClick={() => removeLine(idx)} data-testid={`line-remove-${idx}`}
                className="p-2 rounded hover:bg-red-50 text-red-500 transition-colors">
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}
        {(extracted.line_items || []).length === 0 && (
          <div className="text-center text-sm text-zinc-500 py-6 border border-dashed border-[#E8E4D9] rounded-lg">
            Nessuna riga. Clicca &quot;Aggiungi riga&quot; per iniziare.
          </div>
        )}
      </div>

      <div className="mt-4 rounded-lg border border-[#E8E4D9] bg-[#F5F2EA] p-4">
        <div className="text-[10px] font-semibold text-zinc-500 uppercase tracking-wider mb-1">Somma righe (EUR)</div>
        <div className="font-display font-bold text-2xl tabular-nums" data-testid="somma-righe">
          {fmt(sommaRighe)}
        </div>
      </div>
    </Section>
  );
}
